import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { LoaderSpinnerComponent } from '../../../../components/loader-spinner/loader-spinner.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronRight, faFileCircleInfo, faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { CommonModule } from '@angular/common';
import { DetalleFactura, DocumentoAsociado } from '../../../../interfaces/documento-factura.interface';
import { ImpresionService } from '../../../../services/impresion.service';
import { Subscription } from 'rxjs';
import { HelpersService } from '../../../../services/helpers.service';

faChevronRight
@Component({
  selector: 'app-contenido-carucel',
  standalone: true,
  imports: [LoaderSpinnerComponent, FontAwesomeModule, NgxImageZoomModule, CommonModule],
  templateUrl: './contenido-carucel.component.html',
  styleUrl: './contenido-carucel.component.scss'
})
export class ContenidoCarucelComponent {
  faFileCircleInfo = faFileCircleInfo;
  @Input() listDocAsociados: DocumentoAsociado[] = [];
  @Input() detalleFact!: DetalleFactura;
  @Output() pdfClick = new EventEmitter<any>();
  private subscriptions: Subscription[] = [];


  displayCount: number = 2;
  showShadow: boolean = false;
  noSpace: boolean = false;
  controlPaginadorNormal: boolean = true;
  contentTable: boolean = false;

  currentStartIndex: number = 0;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;

  Math = Math; // Exponer Math para la plantilla
  primeraVez:boolean = true;

  ngOnInit(): void {
    if (this.displayCount < 1) {
      throw new Error('displayCount debe ser al menos 1.');
    }
  }

  constructor(private impresionServices: ImpresionService, private helperService: HelpersService) {

  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['detalleFact']) {
      this.detalleFact = changes['detalleFact'].currentValue;

    }
    if (changes['listDocAsociados']) {
      this.listDocAsociados = changes['listDocAsociados'].currentValue;
      if (this.listDocAsociados) {
        this.listDocAsociados = this.listDocAsociados.filter(item => item.IdTipoDoc !== 21);
        this.processDocuments();
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  openModal(item:any){
    this.pdfClick.emit(item);
  }
  

  processDocuments() {
    if(this.listDocAsociados.length > 0 && this.helperService.esPrimeraVez()){
      this.listDocAsociados.forEach((doc) => {
          doc.error = false;
          doc.loader = true;
          const sub = this.impresionServices.obtenerDocumentoImpresion(doc.IdOrgC, doc.IdDoc, doc.IdTipoDoc, 0, doc.FolioUnico, doc.RutEmisor, doc.TipoDocTributario, doc.EsDte)
            .subscribe({
              next: (response) => {
                if (response) {
                  doc.thumbnail = response.ThumbnailBuffer;
                  doc.fullImage = response.ImagenBuffer;
                  doc.pdfSource = response.ArchivoBuffer;
                  doc.loader = false;
                }
              },
              error: (err) => {
                doc.loader = false;
                doc.error = true;
              }
            });
          this.subscriptions.push(sub);
      });
      this.helperService.modificarPrimeraVez(false);
    }
  }

  get totalItems(): number {
    return this.listDocAsociados.length;
  }

  get visibleItems(): any[] {
    return this.listDocAsociados.slice(
      this.currentStartIndex,
      this.currentStartIndex + this.displayCount
    );
  }

  get dots(): number[] {
    return Array.from({ length: Math.ceil(this.listDocAsociados.length / this.displayCount) }, (_, i) => i);
  }

  isActiveDot(index: number): boolean {
    return index === Math.floor(this.currentStartIndex / this.displayCount);
  }

  goToSlide(index: number): void {
    this.currentStartIndex = index * this.displayCount;
  }

  previous(): void {
    if (this.currentStartIndex > 0) {
      this.currentStartIndex -= this.displayCount;
    }
  }

  next(): void {
    if (this.currentStartIndex + this.displayCount < this.listDocAsociados.length) {
      this.currentStartIndex += this.displayCount;
    }
  }
}

